import React from "react";
import styled from "styled-components";
import Tabs from "../images/tabs.png";
//import BookSVG from "../images/HomeBookBg.svg"; 

// Content inside the book
const BookContent = styled.div`
  width: 93%; 
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5em;
`;

// Articles Layout (Two Columns, inside the book pages)
const ArticlesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: -1.5em;
  width: 100%; 
`;

const ContentTitle = styled.div`
  font-size: clamp(1.6rem, 4vw, .5rem); /* ✅ Shrinks for mobile */
  font-family: "Baskervville", serif;
  font-weight: bold;
  color: #5a3e2b;
  line-height: 1.2;
  word-wrap: break-word;
  margin-top: .5em;
`

const ArticleItem = styled.div`
  width: 70%;

  font-size: 2rem;
  font-weight: bold;
  font-family: "Baskervville", serif;
  color: #222;
  line-height: 1.6;
  text-align: left;
  word-wrap: break-word;
  cursor: pointer;

  &:hover {
    text-decoration: underline; 
  }
`;
const BlueColumn = styled.div`
  width: 15em;
  height: 100em;
  margin-right: -78em;
  margin-top: -88em;
  background-image: url(${Tabs}); 
  background-repeat: no-repeat;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;  
  transform: rotate(-0.5deg);
  z-index: -100;
`;

const Title = styled.h1`
  font-size: clamp(1.6rem, 4vw, 2.12rem); /* ✅ Shrinks for mobile */
  font-family: "Baskervville", serif;
  font-weight: bold;
  color: #5a3e2b;
  margin-bottom: 2rem;
  line-height: 1.2;
  word-wrap: break-word;
`;

const Byline = styled.p`
  font-size: 1.5rem; 
  font-weight: normal;
  color: #666;
  margin-top: 0.5rem;
`;

// Responsive Design (For mobile adjustments)
const MobileStyles = styled.div`
  @media screen and (max-width: 900px) {
    ${BookContent} {
      width: 80%; 
    }
    ${ArticlesContainer} {
      grid-template-columns: 1fr; 
      gap: 2rem;
    }

  }
  
`;



const TitlePage = ({ onTabClick, articles }) => {
  return (
    <>
    
    <svg width="1429" height="1949" viewBox="600 0 1429 1949" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1419.01 159.314C1418.01 158.243 1343.61 159.314 1343.61 159.314H0V1912.41C0 1912.41 1411.02 1908.66 1419.01 1912.41C1427 1916.16 1420.01 160.385 1419.01 159.314Z" fill="#784C2D" stroke="#784C2D"/>
    <path d="M1424.18 153.105C1419.52 149.817 1229.02 151.278 1135 153.79C1151.56 242.019 1321.96 398.338 1427.42 432.589C1428.28 340.797 1428.84 156.393 1424.18 153.105Z" fill="#E0AA3E"/>
    <path d="M1389.41 350.483V186.752C1331.07 185.392 1214.41 183.487 1214.41 186.752C1221.97 221.436 1335.44 344.362 1389.41 350.483Z" stroke="#B38F2C" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1378.41 334.903C1366.81 328.805 1339.08 312.668 1318.41 292.059" stroke="#E0C83E" stroke-width="4" stroke-linecap="round"/>
    <path d="M1377.41 200.529C1378.65 216.749 1379.6 253.214 1379.37 285.655C1379.21 307.884 1378.99 325.598 1378.14 331.982" stroke="#E0CA3E" stroke-width="7" stroke-linecap="round"/>
    <path d="M1425.23 1918C1420.64 1921.29 1232.74 1919.83 1140 1917.31C1156.34 1829 1324.41 1672.54 1428.42 1638.25C1429.27 1730.13 1429.83 1914.71 1425.23 1918Z" fill="#E0AA3E"/>
    <path d="M1391.55 1720.83V1883.96C1333.55 1885.31 1217.55 1887.21 1217.55 1883.96C1225.07 1849.4 1337.89 1726.93 1391.55 1720.83Z" stroke="#B38F2C" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1379.55 1870.76C1380.79 1854.51 1381.75 1817.97 1381.51 1785.46C1381.35 1763.19 1381.13 1745.44 1380.28 1739.04" stroke="#E0CA3E" stroke-width="7" stroke-linecap="round"/>
    <path d="M1236 1873.15C1249.14 1874.6 1309.2 1873.42 1335.48 1873.15C1353.48 1872.96 1367.83 1872.71 1373 1871.71" stroke="#E0CA3E" stroke-width="7" stroke-linecap="round"/>
    <path d="M1393 1706.26C1374.33 1709.83 1274.5 1751.77 1205 1877.6" stroke="#E0CA3E" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1209 178.59C1231.95 177.258 1283.55 176.237 1329.45 176.486C1360.9 176.656 1385.97 176.895 1395 177.807" stroke="#E0CA3E" stroke-width="5" stroke-linecap="round"/>
    <path d="M1237.5 68.9704L1377 228.911V1855.67C1201.91 1854.59 786.013 1848.68 695.328 1834.05C627.568 1823.11 186.366 1816.91 86 1873.13V69.3615C262.617 67.2199 701.951 70.2181 1046.35 99.344L1237.5 68.9704Z" fill="#E1CFBF"/>
    <path d="M86 68.4471C161.112 -68.1918 579.773 44.1451 633.973 49.6175C688.173 55.0899 909.228 95.4293 1016.36 89.6919C1160.61 81.9667 1237 69.4132 1237 69.4132V1695.78C1237 1695.78 1160.61 1708.33 1016.36 1716.06C909.228 1721.79 688.173 1681.45 633.973 1675.98C579.773 1670.51 161.112 1558.17 86 1694.81V68.4471Z" fill="#F6EEE3" stroke="#F6EEE3"/>
    <path d="M1377 1855.21L1237.5 1695.98V68.9704L1377 229.152V1855.21Z" fill="#EFE2D7"/>
    <path d="M81.2739 1945.54C54.9181 1948.54 3.08504 1936.24 -16.8282 1929.03C-23.7724 1926.52 -32.8846 1913.36 -37.3271 1905.03C-48.8088 1883.51 -53.7412 1856.19 -43.1839 1807.51C-35.9989 1774.39 -4.57417 1751.23 27.0981 1736.66C47.0608 1727.48 67.1219 1721.71 81.2739 1719C95.4259 1721.71 115.487 1727.48 135.45 1736.66C167.122 1751.23 198.547 1774.39 205.732 1807.51C216.289 1856.19 217.213 1883.51 205.732 1905.03C201.289 1913.36 186.32 1926.52 179.376 1929.03C159.463 1936.24 107.63 1948.54 81.2739 1945.54Z" fill="#784C2D" stroke="#6A3D1D" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M389.5 1751C426.167 1745.83 585 1751 710.5 1773.5C859.37 1795.01 925.175 1799.27 945.981 1798.6C948.372 1798.45 950.552 1798.25 952.5 1798C951.286 1798.29 949.158 1798.5 945.981 1798.6C886.993 1802.33 699.084 1776.08 676.5 1773.5C609.739 1765.87 475.5 1751 389.5 1751Z" fill="#BBA795"/>
    <path d="M994 1761.34C866 1754.24 796.5 1747.48 763.5 1744C824.5 1750.5 887.5 1757 961 1761.34C984.612 1762.73 1166.5 1776.5 1223.5 1752.5C1195 1757 1192.5 1768.5 994 1761.34Z" fill="#BBA795"/>
    <path d="M1110 1829.5C982 1822.4 976 1820 923 1820C995 1822.91 977 1823.5 1050.5 1827.84C1074.11 1829.23 1252 1845.87 1324 1834.5C1295.5 1839 1143.31 1834.5 1110 1829.5Z" fill="#BBA795"/>
    <path d="M217 1802.5C221.167 1795.83 237.7 1783.8 256.5 1783C276.998 1782.13 275.812 1778.97 354.148 1788.47C375.337 1790.53 391.176 1792.89 394 1793.5C378.798 1791.52 365.62 1789.86 354.148 1788.47C306.313 1783.81 231.207 1780.67 217 1802.5Z" fill="#BBA795" stroke="#BBA795" stroke-width="2" stroke-linecap="round"/>
    <path d="M1268.5 780.5C1272.5 692.1 1270.17 322.333 1268.5 148.5C1271.17 319.667 1280.58 737 1278 780.5C1273.5 856.5 1268.5 1118 1268.5 1272.5C1259 1192.5 1263.5 891 1268.5 780.5Z" fill="#E1D3C6"/>
    <path d="M1347.56 1287C1351.56 1198.6 1349.23 828.833 1347.56 655C1350.23 826.167 1359.64 1243.5 1357.06 1287C1352.56 1363 1339.18 1609.5 1347.56 1779C1331.5 1684 1339.12 1473.5 1347.56 1287Z" fill="#E1D3C6"/>
    <path d="M1326.4 1013.5C1330.4 925.1 1332.67 731.833 1331 558C1333.67 729.167 1335.08 970 1332.5 1013.5C1329.6 1062.5 1318.02 1158.5 1326.4 1328C1310.34 1233 1317.96 1200 1326.4 1013.5Z" fill="#E1D3C6"/>
    <path d="M1262.5 1686.5C1260.83 1678 1257.4 1655.5 1257 1633.5C1256.55 1608.5 1261.46 1540.94 1262.36 1513.09C1262.44 1504.56 1262.5 1501.07 1262.5 1506C1262.5 1507.91 1262.45 1510.3 1262.36 1513.09C1262.09 1540.87 1261.5 1622.13 1261.5 1639.5C1261.5 1650.5 1263.5 1678.67 1262.5 1686.5Z" fill="#E1CFBF"/>
    <path d="M1283.53 1428.76C1281.86 1420.26 1278.43 1397.76 1278.03 1375.76C1277.58 1350.76 1282.49 1283.2 1283.39 1255.34C1283.47 1246.82 1283.53 1243.33 1283.53 1248.26C1283.53 1250.17 1283.48 1252.56 1283.39 1255.34C1283.12 1283.13 1282.53 1364.39 1282.53 1381.76C1282.53 1392.76 1284.53 1420.92 1283.53 1428.76Z" fill="#E1CFBF"/>
    <path d="M1300.53 427.5C1298.86 419 1296.43 326.758 1296.03 304.758C1295.58 279.759 1300.49 212.202 1301.39 184.345C1301.47 175.82 1301.53 172.328 1301.53 177.258C1301.53 179.168 1301.48 181.558 1301.39 184.345C1301.12 212.131 1300.53 293.388 1300.53 310.758C1300.53 321.758 1301.53 419.667 1300.53 427.5Z" fill="#E1CFBF"/>
    <path d="M1297.53 830.5C1295.86 822 1293.43 729.758 1293.03 707.758C1292.58 682.759 1297.49 615.202 1298.39 587.345C1298.47 578.82 1298.53 575.328 1298.53 580.258C1298.53 582.168 1298.48 584.558 1298.39 587.345C1298.12 615.131 1297.53 696.388 1297.53 713.758C1297.53 724.758 1298.53 822.667 1297.53 830.5Z" fill="#E1CFBF"/>
    <path d="M1342 436.5C1356.74 360.974 1346 248.5 1342 204C1351.67 244.667 1358.1 339 1354.5 379C1351.25 415.095 1335.16 504.934 1328.72 573.198C1328.15 583.368 1327.64 590.875 1327 594.5C1327.44 587.716 1328.03 580.583 1328.72 573.198C1330.51 541.281 1332.9 483.139 1342 436.5Z" fill="#E1D3C6"/>
    <path d="M211.758 10H325C325.218 550.936 329.912 1619.62 329.999 1629.5C329.999 1629.5 330 1629.5 330 1629.5C330 1629.59 330 1629.59 329.999 1629.5C315.495 1627 228.636 1631 187 1634.5C187 1605.99 185.209 1618.06 185.209 1592.86C179.261 1431.32 196.444 1091.74 210.984 876.196C222.616 703.757 216.605 220.881 211.758 10Z" fill="#FAF1E6"/>
    <path d="M1151.5 82.5L1236.5 71C1236.67 616.833 1237 1706 1237 1696C1228.6 1697.6 1163.5 1705 1132 1708.5V1675.5C1127.5 1514 1140.5 1146 1151.5 930.5C1160.3 758.1 1155.17 293.333 1151.5 82.5Z" fill="#FAF1E6"/>
    <path d="M80 1697V70.132C62.8 38.5737 19.5 20.228 2.64272e-05 15V39.7143L6.20637e-06 72.0331L2.64272e-05 1581.03C0.33336 1585.94 2.64262e-05 1596.72 2.64272e-05 1615.73V1641.87C48.8 1655.18 73.6667 1684.17 80 1697Z" fill="#E1CFBF"/>
    <path d="M80 1697V70.132C62.8 38.5737 19.5 20.228 0 15V28.783C0.166667 29.2583 3.7 30.3039 8.5 34.4863C35.5 53.9726 33.2479 59.5541 34 60.6264C35 62.0523 39 83.4397 39 91.5194V1616.68C37.5 1623.81 31 1629.25 27 1630.94C16.2 1635.5 9.5 1635.21 0 1633.31V1641.87C48.8 1655.18 73.6667 1684.17 80 1697Z" fill="#C9B4A1"/>
    <path d="M82 1697L81 70.161C100.5 34.516 149.5 12.1785 206.5 6L190.5 11.2279L183.5 14.5548C183.5 14.5548 181.366 15.7118 180 16.4559C173.927 19.7642 168.5 25.0107 168.5 25.0107L161.5 30.7139L158.5 34.516C152.5 43.5461 152 56.3783 152 59.2299V89.647L154 1606.7C155.5 1613.83 166 1630.2 170 1631.89C180.8 1636.45 200.5 1633.31 219 1631.89C189.5 1634.16 162 1641.58 162 1642.34C113.2 1655.65 88.3333 1684.17 82 1697Z" fill="#EFE2D7"/>
    <path d="M82 1697L81 70.161C100.5 34.516 149.5 12.1785 206.5 6L190.5 11.2279L183.5 14.5548C183.5 14.5548 181.366 15.7118 180 16.4559C173.927 19.7642 164.5 25.0107 164.5 25.0107L152 33.5655C125 53.0514 128.752 59.5834 128 60.6557C127 62.0815 123 83.4685 123 91.548V1616.68C124.5 1623.81 131 1629.25 135 1630.94C145.8 1635.5 200.5 1633.31 219 1631.89C189.5 1634.16 162 1641.58 162 1642.34C113.2 1655.65 88.3333 1684.17 82 1697Z" fill="#E1CFBF"/>
    <path d="M80 1700V70.1368C58.5 34.488 23.5 21.1791 0 15C0.166667 15.4753 17.7 23.6508 22.5 27.8336C49.5 47.3216 53.5 63.4824 55.5 66.3343C58.1667 70.1368 62.5 86.2976 62.5 94.378V1619.2C62.5 1625.85 60.5619 1635.31 57 1637.73C53.5 1640.11 27.5 1646.29 18 1644.39C18 1645.66 0 1641.25 0 1642.01C48.8 1655.32 73.6667 1687.17 80 1700Z" fill="#784C2D"/>
    <path d="M214 13.2616C380.106 -8.28914 733.013 83.8669 954.472 87.6898C1144.45 90.9693 1224.52 67.0761 1228 70.824" stroke="#FAF9F8" stroke-width="15" stroke-linecap="round"/>
    <path d="M204 1850C200.993 1765.14 115.952 1742.38 79.1956 1737.16C68.3692 1735.01 18.5477 1754.7 -1 1769.88V1813.97C50.6259 1791.68 76.1883 1794.06 79.1956 1792.16C82.2029 1790.26 164.403 1797.85 204 1850Z" fill="#6A3D1D" stroke="#6A3D1D" stroke-width="15" stroke-linecap="round"/>
    <path d="M1399 1891C1206.6 1888.78 823.01 1885.21 821.81 1882.93C820.31 1880.08 574.228 1871.54 546.219 1870.59C518.496 1869.65 221.274 1871.96 217.144 1882.6C217.131 1882.7 217.118 1882.8 217.105 1882.89C217.106 1882.9 217.108 1882.92 217.111 1882.93C217.09 1883.05 217.071 1883.16 217.052 1883.27C216.594 1885.91 216.73 1885.55 217.052 1883.27C217.069 1883.15 217.087 1883.02 217.105 1882.89C217.094 1882.79 217.107 1882.69 217.144 1882.6C218.138 1875.23 220.318 1853.48 214.61 1841.63C186.601 1841.63 531.214 1816.47 689.766 1834.51C848.319 1852.55 1372.99 1855.87 1376.49 1855.87C1379.99 1855.87 1391 1878.66 1399 1891Z" fill="black" fill-opacity="0.12"/>
   
    <foreignObject x="90" y="10" width="100%" height="100%">
      <BookContent>
      <ContentTitle>TABLE OF CONTENTS</ContentTitle>
        <ArticlesContainer>
          {Array.isArray(articles) && articles.length > 0 ? (
            articles.map((article, index) => (
              <ArticleItem key={index}>
                <a  href={article.article_url}  target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <Title>{article.article_title}</Title>
                <Byline>by {article.article_byline}</Byline>
                </a>
              </ArticleItem>
            ))
          ) : (
            <p>Loading articles...</p> // Prevents crash when no articles are available
          )}
        </ArticlesContainer>
        <BlueColumn onClick={() => onTabClick(0)}></BlueColumn>
      </BookContent>
    </foreignObject>
    </svg>
    </>
  );
};

export default TitlePage;
